/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { MouseEvent, MouseEventHandler, useEffect, useState } from 'react';
import './toggle.css';

type ToggleProps = {
    onClick?: MouseEventHandler<HTMLInputElement>;
    defaultValue?: boolean;
    className?: string;
    id?: string;
};

const Toggle = ({ onClick, defaultValue, className, id }: ToggleProps) => {
    const [checked, setChecked] = useState<boolean>(defaultValue ?? false);

    const handleClick = (e: MouseEvent<HTMLInputElement>) => {
        onClick?.(e);
        setChecked((prev) => !prev);
    };

    useEffect(() => {
        setChecked(defaultValue ?? false);
    }, [defaultValue]);

    return (
        <label className={`switch ${className}`}>
            <input type="checkbox" checked={checked} id={id} onClick={handleClick} />
            <span className="slider round" />
        </label>
    );
};

export default Toggle;
